import React, { useEffect, useState } from "react";

const Text = ({
  value:initialValue = "",
  onChange,
  placeholder = "",
  type="text",
  className = "input-text",
  name,
  id,
  min,
  max,
  required = false,
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(initialValue)
  }, [initialValue]);

  const handleChange = (e) => {
    setValue(e.target.value);
    if (onChange) {
      onChange(e.target.value);
    }
  };

  return (
    <>
      <input
        id={id}
        className={className}
        name={name}
        type={type}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        min={min}
        max={max}
        required={required}
      />
    </>
  );
};


export default Text;
